@if (showSearchType) {
  <mat-select [(ngModel)]="selectValue" [disableOptionCentering]="true" (selectionChange)="onSelectionChangeForSearchType()"
              panelClass="hk-search-select-panel mat-elevation-z4" [class.mat-elevation-z4]="showDropShadows" [class.min-w-44]="hasGroups"
              class="search-type w-fit px-4 pt-3 me-[0.559rem] {{showBorder ? 'border border-outline-variant rounded-sm' : 'rounded-md'}}"


  >
    @if (hasGroups) {
      <!-- Query Types are grouped -->
      @for (group of groupedOptions; track $index) {
        <mat-optgroup [label]="group.name">
          @for (option of group.options; track $index) {
            <mat-option [value]="`${group.name}:${option.queryType}`">{{ option.displayableName }}</mat-option>
          }
        </mat-optgroup>
      }
    } @else {
      <!-- Query Types are a standard array -->
      @for (option of options; track $index) {
        <mat-option [value]="option.queryType">{{ option.displayableName }}</mat-option>
      }
    }
  </mat-select>
}

<div class="flex flex-row w-full rounded-md bg-surface" [class.mat-elevation-z4]="showDropShadows" [ngClass]="{'min-w-[12.75rem]': hasMinWidth}">
  <input matInput #input [(ngModel)]="query" (keydown)="onKeydown($event)" (keyup)="onKeyup()" [placeholder]="placeholderText"
         class="w-full m-0 {{showBorder ? 'border-y border-s border-outline-variant rounded-r-none rounded-l-sm h-[3.0625rem]' : 'rounded-md h-12'}}"/>

  @if (showClearButton) {
    <div class="{{showBorder ? 'border-y border-outline-variant rounded-none h-[3.0625rem]' : ''}}">
      <mx-icon-button icon="clear" color="on-surface-variant" (click)="onClickClearButton()" class="m-1"/>
    </div>
  }

  <!--
    When showBorder is:
     - true  -- We match the button's size to the input field's height, grow the icon to fit, remove the left side rounding, and change the right side rounding.
     - false -- We create a smaller button that fits inside the input field itself, and make the icon smaller to fit.
  -->
  <mx-filled-button startIcon="search" [startIconClasses]="showBorder ? 'mat-icon-size-6' : 'mat-icon-size-4.5'" (click)="onClickSearchButton()"
                    [class]="
                      showBorder
                        ? '[--mx-button-filled-icon-only-size:3.0625rem] [--mx-button-container-shape:0_0.25rem_0.25rem_0]'
                        : '[--mx-button-filled-icon-only-size:2.5rem] m-1'
                    "/>
</div>
